import React from "react";
import { connect } from "react-redux";
import { SketchPicker } from "react-color";
import {
    Row,
    Col,
    Label,
    CardBody
} from "reactstrap";
import { units } from "../../../../../../common/units";
import { templateActions } from "../../../../../../store/actions/cms/template/template.action";
import { DropDownFacade } from "../../../../../../components/UI/Buttons/DropDownFacade";
import ColorPickerFacade from "../../../../../../components/UI/Buttons/ColorPickerFacade";
import SystemLabel from "../../../../../../system/SystemLabel/SystemLabel";
import Slider, { createSliderWithTooltip } from "rc-slider";
import JirangoFontPicker from "../../../../../../fonts/FontPicker";
import { deepClone, setValueToNestedObject } from "../../../../../../helpers/objectHelper";
import { templateHelper } from "../../../helpers/templateHelper";
import EditorSlider from "../../../../../components/editor/tools/EditorSlider";
import { FontWeightPicker } from "../../../../../../fonts/FontWeightPicker/FontWeightPicker";
import { UrlMultiInput } from "../../../../../components/editor/tools/UrlMultiInput/UrlMultiInput";
import { hexToRgb } from "../../../../../../helpers/colorHelper";
import CropPortraitTwoToneIcon from '@material-ui/icons/CropPortraitTwoTone';
import BorderTopTwoToneIcon from '@material-ui/icons/BorderTopTwoTone';
import ListExpansion from "../../../../../../components/UI/ListExpansion/ListExpansion";
import TocTwoToneIcon from '@material-ui/icons/TocTwoTone';
import ForumTwoToneIcon from '@material-ui/icons/ForumTwoTone';
import PaletteTwoToneIcon from '@material-ui/icons/PaletteTwoTone';
import BorderBottomTwoToneIcon from '@material-ui/icons/BorderBottomTwoTone';
import TitleTwoToneIcon from '@material-ui/icons/TitleTwoTone';
import TextFieldsTwoToneIcon from '@material-ui/icons/TextFieldsTwoTone';
import BusinessCenterTwoToneIcon from '@material-ui/icons/BusinessCenterTwoTone';

class ExhibitorSettings extends React.Component {
    handleUpdate = template => {
        const { dispatch } = this.props;
        dispatch(templateActions.softUpdate(template));
    };
    handleUnitChange = (unit, path) => {
        const { template } = this.props;
        const names = path.split(".");
        let templateCopy = deepClone(template);
        const cu = templateHelper.nestledFind(path, templateCopy.content)
        let val = parseInt(cu)
        templateCopy.content = deepClone(
            setValueToNestedObject(names, val + unit, templateCopy.content)
        );
        this.handleUpdate(templateCopy);
    };
    setBackgroundImage = url => {
        const { template } = this.props;
        const templateCopy = deepClone(template);
        templateCopy.content.interaction.connections.background = `url('${url}')  no-repeat center center / cover`;
        templateCopy.content.interaction.connections.backgroundSize = `cover`;
        templateCopy.content.interaction.connections.backgroundUrl = url;
        this.handleUpdate(templateCopy);
    };
    handleChange = (color, e, path, fallbackUnit = null) => {
        const { template } = this.props;
        const names = path.split(".");
        let templateCopy = deepClone(template);
        let value = templateHelper.getValueFromInput(e, color);
        let unit = templateHelper.getUnit(templateCopy, names);
        if (parseFloat(value)  && unit.length < 4) {
            value += unit;
        }
        templateCopy.content = deepClone(
            setValueToNestedObject(names, value, templateCopy.content)
        );
        if (path == 'interaction.connections.backgroundColor') {
            templateCopy.content.interaction.connections.background = templateHelper.parseColorToRgba(color);
        }
        this.handleUpdate(templateCopy);
    };
    render() {
        const { template } = this.props;
        if (template === undefined || template.content.interaction.connections === undefined) return null;
        return (
            <div>
                <div style={{ paddingTop: "10px", margin: '0px -10px' }}>
                    <ListExpansion footer={false} icon={<CropPortraitTwoToneIcon />} description="ContainerStyles">
                        <br />
                        <Row>
                            <Col className="list-setting-item-title">
                                <Label>
                                    <SystemLabel name="BackgroundColor" />
                                </Label>
                            </Col>
                            <Col className="list-setting-item-input">
                                <ColorPickerFacade
                                    color={template.content.interaction.exhibitor.frame.background}
                                    onChange={(color, e) =>
                                        this.handleChange(color, e, "interaction.exhibitor.frame.background")
                                    }
                                    path="interaction.exhibitor.frame.background"
                                />
                            </Col>
                        </Row>
                        <br />
                        <EditorSlider
                            value={templateHelper.getValueWithoutUnit(
                                template,
                                "interaction.exhibitor.frame.borderRadius"
                            )}
                            defaultValue={0}
                            unitChange={this.handleUnitChange}
                            onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                            units={["px", "rem", "%"]}
                            activeUnit={templateHelper.getUnit(template, "interaction.exhibitor.frame.borderRadius")}
                            steps={1}
                            max={100}
                            min={1}
                            path={"interaction.exhibitor.frame.borderRadius"}
                            label="BorderRadius"
                        />
                        <hr />
                        <EditorSlider
                            value={templateHelper.getValueWithoutUnit(
                                template,
                                "interaction.exhibitor.frame.padding"
                            )}
                            defaultValue={0}
                            unitChange={this.handleUnitChange}
                            onChange={(color, e, path, extraParam) => this.handleChange(color, e, path, extraParam)}
                            units={["px", "rem", "%"]}
                            activeUnit={templateHelper.getUnit(template, "interaction.exhibitor.frame.padding")}
                            steps={1}
                            max={100}
                            min={1}
                            path={"interaction.exhibitor.frame.padding"}
                            label="Padding"
                        />
                    </ListExpansion>
                </div>
                <div style={{ paddingTop: "10px", margin: '0px -10px' }}>
                    <ListExpansion footer={false} icon={<BusinessCenterTwoToneIcon />} description="LogoStyle">
                        <br />
                        <Row>
                            <Col className="list-setting-item-title">
                                <Label>
                                    <SystemLabel name="LogoBackgroundColor" />
                                </Label>
                            </Col>
                            <Col className="list-setting-item-input">
                                <ColorPickerFacade
                                    color={template.content.interaction.exhibitor.logo.background}
                                    onChange={(color, e) =>
                                        this.handleChange(color, e, "interaction.exhibitor.logo.background")
                                    }
                                    path="interaction.exhibitor.logo.background"
                                />
                            </Col>
                        </Row>
                        <br />
                      
                    </ListExpansion>
                </div>

                <div style={{ paddingTop: "10px", margin: '0px -10px' }}>
                    <ListExpansion footer={false} icon={<TitleTwoToneIcon />} description="Title">
                        <Row>
                            <Col className="list-setting-item-title">
                                <Label>
                                    <SystemLabel name="TextColor" />
                                </Label>
                            </Col>
                            <Col className="list-setting-item-input">
                                <ColorPickerFacade
                                    color={template.content.interaction.exhibitor.title.color}
                                    onChange={(color, e) =>
                                        this.handleChange(color, e, "interaction.exhibitor.title.color")
                                    }
                                    path="interaction.exhibitor.title.color"
                                />
                            </Col>
                        </Row>

                        <br />

                        <hr />
                        <JirangoFontPicker
                            onChange={this.handleChange}
                            path="interaction.exhibitor.title.fontFamily"
                            currentFontFamily={
                                template && template.content.interaction.exhibitor.title.fontFamily
                            }
                        />
                        <FontWeightPicker
                            onChange={this.handleChange}
                            path="interaction.exhibitor.title.fontWeight"
                            currentFont={template.content.interaction.exhibitor.title.fontFamily}
                            weight={template.content.interaction.exhibitor.title.fontWeight}
                        />
                        <hr />
                        <EditorSlider
                            value={templateHelper.getValueWithoutUnit(
                                template,
                                "interaction.exhibitor.title.fontSize"
                            )}
                            defaultValue={0}
                            unitChange={this.handleUnitChange}
                            onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                            units={["px", "rem", "%"]}
                            activeUnit={templateHelper.getUnit(template, "interaction.exhibitor.title.fontSize")}
                            steps={1}
                            max={100}
                            min={1}
                            path={"interaction.exhibitor.title.fontSize"}
                            label="FontSize"
                        />

                    </ListExpansion>
                </div>
                <div style={{ paddingTop: "10px", margin: '0px -10px' }}>
                    <ListExpansion footer={false} icon={<TextFieldsTwoToneIcon />} description="Subtitle">
                        <Row>
                            <Col className="list-setting-item-title">
                                <Label>
                                    <SystemLabel name="TextColor" />
                                </Label>
                            </Col>
                            <Col className="list-setting-item-input">
                                <ColorPickerFacade
                                    color={template.content.interaction.exhibitor.subtitle.color}
                                    onChange={(color, e) =>
                                        this.handleChange(color, e, "interaction.exhibitor.subtitle.color")
                                    }
                                    path="interaction.exhibitor.subtitle.color"
                                />
                            </Col>
                        </Row>

                        <br />

                        <hr />
                        <JirangoFontPicker
                            onChange={this.handleChange}
                            path="interaction.exhibitor.subtitle.fontFamily"
                            currentFontFamily={
                                template && template.content.interaction.exhibitor.subtitle.fontFamily
                            }
                        />
                        <FontWeightPicker
                            onChange={this.handleChange}
                            path="interaction.exhibitor.subtitle.fontWeight"
                            currentFont={template.content.interaction.exhibitor.subtitle.fontFamily}
                            weight={template.content.interaction.exhibitor.subtitle.fontWeight}
                        />
                        <hr />
                        <EditorSlider
                            value={templateHelper.getValueWithoutUnit(
                                template,
                                "interaction.exhibitor.subtitle.fontSize"
                            )}
                            defaultValue={0}
                            unitChange={this.handleUnitChange}
                            onChange={(color, e, path, extraParam) => this.handleChange(color, e, path)}
                            units={["px", "rem", "%"]}
                            activeUnit={templateHelper.getUnit(template, "interaction.exhibitor.subtitle.fontSize")}
                            steps={1}
                            max={100}
                            min={1}
                            path={"interaction.exhibitor.subtitle.fontSize"}
                            label="FontSize"
                        />

                    </ListExpansion>
                </div>
                <br />


            </div>


        );
    }
}
function mapStateToProps(state) {
    return {
        alert: state.alert,
        template: state.template.template
    };
}
export default connect(mapStateToProps)(ExhibitorSettings);
